export default __webpack_public_path__ + "static/media/foundation.db8ae83b.jpg";